import { SxStyles } from 'src/types/theme';

const styles: SxStyles = {
  wrapper: {
    width: '520px',
    minHeight: '250px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    marginTop: '24px',
  },
  rateWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  rateField: {
    width: '53px',
    marginLeft: 1,
    mr: 2,
  },
  rateInput: {
    padding: '10px',
  },
  rateInputAdornmentStart: {
    marginLeft: 0,
    marginRight: 0,
  },
  rateInputAdornmentEnd: {
    marginLeft: 0,
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: '40px',
  },
  button: {
    marginRight: '10px',
    paddingLeft: '48px',
    paddingRight: '48px',
  },
};

export default styles;
